import type { FC, SVGProps } from "react";

const AngleUpIcon: FC<SVGProps<SVGSVGElement>> = (props) => {
  return (
    <svg
      width="28"
      height="16"
      viewBox="0 0 28 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      role="img"
      aria-labelledby="titleId"
      {...props}
     aria-label="angle left icon">
      {/* <title>angle left icon</title> */}
      <path
        d="M3.41421 15.4142C2.63317 16.1953 1.36684 16.1953 0.585786 15.4142C-0.195262 14.6332 -0.195262 13.3668 0.585786 12.5858L12.5858 0.585789C13.3429 -0.171369 14.5621 -0.19786 15.3514 0.525694L27.3514 11.5257C28.1657 12.2721 28.2207 13.5372 27.4743 14.3515C26.7279 15.1657 25.4628 15.2207 24.6486 14.4743L14.0602 4.76828L3.41421 15.4142Z"
        fill={props.fill || "currentColor" || "black"}
      />
    </svg>
  );
};

export default AngleUpIcon;
